export default __webpack_public_path__ + "static/media/Use-Cases-Section-Hackathon.2d15957a.jpg";